function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Group 5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.582 27.652",
  preserveAspectRatio: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 11",
  d: "M28.948 13.1h-6.8l4.808-4.791a2.624 2.624 0 00-3.719-3.7L18.423 9.4V2.617A2.619 2.619 0 0016.8.2a2.646 2.646 0 00-2.87.567 2.612 2.612 0 00-.77 1.851V9.4L8.347 4.607a2.625 2.625 0 10-3.723 3.7L9.436 13.1h-6.8A2.628 2.628 0 000 15.722a2.619 2.619 0 001.626 2.419 2.641 2.641 0 001.008.2h6.8l-4.81 4.789a2.627 2.627 0 003.723 3.706l7.442-7.413 7.446 7.413a2.636 2.636 0 004.291-.85 2.61 2.61 0 00-.572-2.856l-4.808-4.791h6.8a2.628 2.628 0 002.433-1.615 2.617 2.617 0 00-.569-2.859 2.64 2.64 0 00-1.864-.769z",
  fill: "#ffc24d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M26.954 23.126l-7.442-7.408-1.844-1.836a2.659 2.659 0 00-3.753 0l-1.845 1.836-7.446 7.408a2.627 2.627 0 103.723 3.706l5.576-5.551a2.659 2.659 0 013.753 0l5.576 5.551a2.625 2.625 0 103.719-3.706z",
  fill: "#f60"
})));